import { DISABLE_EBU_SINGLE_PURCHASE } from '@Config/features.config';
import { DOCUMENT_TYPE_FOR_EBU_USER } from '@Config/app.config';

export const getB2bUser = (documentType: string): boolean => {
	return DOCUMENT_TYPE_FOR_EBU_USER.includes(documentType) && !DISABLE_EBU_SINGLE_PURCHASE;
};
